import {
    CountryCodeToCountryName,
    createLocationCityOption,
    createLocationCountryCodeOption,
    createLocationRegionOption,
    Facet,
    SelectOption,
} from 'containers/jobs-board/components/options'
import { queryParamName } from 'containers/jobs-board/hooks/useParams'

export const getAvailableRegions = (facets?: Facet[]) => {
    return (facets || [])
        ?.filter(facet => facet.attr === queryParamName.locationRegion)
        .map(facet => ({
            ...createLocationRegionOption(facet.value),
            count: facet.count,
        }))
}

export const getAvailableCities = (facets?: Facet[]) => {
    return (facets || [])
        ?.filter(facet => facet.attr === queryParamName.locationCity)
        .map(facet => ({ ...createLocationCityOption(facet.value), count: facet.count }))
}

export const getAvailableCountries = (
    countryCodeToCountryName: CountryCodeToCountryName,
    facets?: Facet[],
) => {
    return (facets || [])
        ?.filter(
            facet =>
                facet.attr === queryParamName.locationCountryCode &&
                countryCodeToCountryName[facet.value],
        )
        .map(facet => ({
            ...createLocationCountryCodeOption(
                countryCodeToCountryName[facet.value],
                facet.value,
            ),
            count: facet.count,
        }))
}

export const getLocationInputOptions = (
    countryCodeToCountryName: CountryCodeToCountryName,
    facets?: Facet[],
): SelectOption[] => {
    return [
        ...getAvailableCities(facets),
        ...getAvailableCountries(countryCodeToCountryName, facets),
        ...getAvailableRegions(facets),
    ].sort((a, b) => b.count - a.count)
}
